export const isValidTakeawayPhone = (value) => {
  const phone = String(value || "").trim();
  if (!phone) return true;
  return /^(?:\+91[ -]?)?[6-9][0-9]{9}$/.test(phone);
};

